import styled from 'styled-components'
import { ReactNode } from 'react'

interface PopoverOptionProps {
  children: ReactNode
  onClick?: () => void
  className?: string
}

const StyledDiv = styled.div`
  padding: 4px;
  border-radius: 9px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.color.neutral.color9};
  }
`

const PopoverOption = ({
  children,
  onClick,
  className,
}: PopoverOptionProps) => (
  <StyledDiv onClick={onClick} className={className}>
    {children}
  </StyledDiv>
)

export default PopoverOption
